function decodeHtmlEntities(value) {
  return value
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">");
}

function extractMetaContent(html, propertyName) {
  const metaRegex = new RegExp(
    `<meta[^>]+(?:property|name)=["']${propertyName}["'][^>]+content=["']([^"']+)["'][^>]*>`,
    "i"
  );
  return html.match(metaRegex)?.[1] || null;
}

export function extractPortalNameFromHtml(html) {
  if (typeof html !== "string" || !html.trim()) {
    return null;
  }

  const candidates = [
    extractMetaContent(html, "og:title"),
    extractMetaContent(html, "twitter:title"),
    html.match(/<title[^>]*>([^<]+)<\/title>/i)?.[1] || null
  ]
    .map(value => (typeof value === "string" ? decodeHtmlEntities(value).trim() : null))
    .filter(Boolean);

  if (!candidates.length) {
    return null;
  }

  const [rawTitle] = candidates;
  return rawTitle.split("|")[0].trim() || null;
}
